module.exports = __webpack_public_path__ + "static/media/plus.d7b45191.svg";